//open modal if data-modal-target exists
const openButtons = document.querySelectorAll('.button:not(.disabled)');
Array.from(openButtons).forEach(button => {
	if(typeof button.dataset.modalTarget !== 'undefined')
	{
	    button.addEventListener('click', function() {
			openModal(this);
			document.querySelector('body').classList.add('noscroll');
		});
	}
});

//close when .modal-close is clicked
const closeButtons = document.querySelectorAll('.modal-close');
Array.from(closeButtons).forEach(button => {
    button.addEventListener('click', function() {
		closeModal();
	});
});

//close on overlay click
let overlay = document.querySelector('.modal-overlay');
if(typeof overlay == null)
{
	overlay.addEventListener('click', function() {
		closeModal();
	});
}

function openModal(target)
{
	document.querySelector('body').classList.toggle('active-modal');
	document.querySelector('body').classList.toggle('overlay-close');

	if(target.dataset.modalTarget)
	{
		document.querySelector('.' + target.dataset.modalTarget).classList.toggle('current-modal');
	}
	else
	{
		target.nextSibling.classList.toggle('current-modal');
	}
}

function closeModal()
{
	document.querySelector('body').classList.remove('noscroll');
	document.querySelector('body').classList.remove('active-modal');
	document.querySelector('body').classList.remove('overlay-close');
	document.querySelector('.current-modal').classList.remove('current-modal');
}